import { z } from 'zod'
import { defineAction, enumerated } from '~/prix'
import routingGraphListAction from './routingGraphList.action.json' with { type: 'json' }
import { routingGraphEdgeObject } from '../routingGraphObject'

const routingGraphListDefinition = defineAction({
  ...routingGraphListAction,
  input: z.object({
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().min(0).nullish(),
    orderBy: enumerated({
      key: 'Chave',
      sourceRoadKey: 'Estrada de origem',
      municipalityId: 'Município',
      synchronizedAt: 'Data de sincronização',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
  }),
  output: z.object({
    items: z.array(routingGraphEdgeObject),
    count: z.number(),
  }),
})

export default routingGraphListDefinition
